import i18n from '@application/utilities/i18n';
// Default background image from local assets
export const DEFAULT_BACKGROUND_IMAGE_URLS = [
    '/assets/images/defaultBg.jpg',
    '/assets/images/red-bg.jpg',
    '/assets/images/skyBlue-bg.jpg',
    '/assets/images/yellow-bg.jpg',
    '/assets/images/oceanBlue-bg.jpg',
    '/assets/images/green-bg.jpg',
    '/assets/images/darkBlue-bg.jpg',
    '/assets/images/orange-bg.jpg'
];
export const assetToFile = async (assetUrl, filename = 'defaultBg.jpg') => {
    const response = await fetch(assetUrl);
    const blob = await response.blob();
    return new File([blob], filename, { type: blob.type || 'image/png' });
};
// Helper function to convert URL to File object
export const urlToFile = async (url, filename) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new File([blob], filename, { type: blob.type });
};
export const prepareBackgroundImagesForUpload = async (backgroundImages) => {
    const preparedImages = [];
    for (const image of backgroundImages) {
        try {
            if (image.file) {
                // Newly uploaded image
                preparedImages.push({
                    image: image.file,
                    isBackgroundImage: Boolean(image.isSelected || image.isBackgroundImage),
                    isCustomImage: Boolean(image.isCustomImage)
                });
            }
        }
        catch (error) {
            // If processing fails, skip this image
        }
    }
    return preparedImages;
};
export const validateBackgroundImages = (files) => {
    const errors = [];
    const IMAGE_MAX_SIZE = 2 * 1024 * 1024; // 2MB
    const VIDEO_MAX_SIZE = 20 * 1024 * 1024; // 20MB
    const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'video/mp4'];
    const allowedTypesString = 'JPEG, PNG, WebP and MP4';
    files.forEach((file, index) => {
        if (!ALLOWED_TYPES.includes(file.type)) {
            errors.push(i18n.t('validations.imageTypeNotAllowed', {
                allowedTypes: allowedTypesString
            }));
            return;
        }
        if (file.type === 'video/mp4') {
            if (file.size > VIDEO_MAX_SIZE) {
                errors.push(i18n.t('validations.fileSizeTooLarge', {
                    fileNumber: index + 1,
                    maxSize: '20MB'
                }));
            }
        }
        else {
            if (file.size > IMAGE_MAX_SIZE) {
                errors.push(i18n.t('validations.fileSizeTooLarge', {
                    fileNumber: index + 1,
                    maxSize: '2MB'
                }));
            }
        }
    });
    return errors;
};
// Helper function to check if an image is the default background image
export const isDefaultBackgroundImage = (image) => {
    return (image.isDefaultImage === true ||
        (image.url ? DEFAULT_BACKGROUND_IMAGE_URLS.includes(image.url) : false));
};
